import rill from "rill";
import redirect from "@rill/redirect";
import get from "lodash/get";
import ensureUser from "../../middleware/ensure-user";
import ensureCoach from "../../middleware/ensure-coach";
import ensureSetup from "../../middleware/ensure-setup";
import ensurePaid from "../../middleware/ensure-paid";

import Calendar from "./calendar";
import Metrics from "./metrics";
import Profile from "./profile";
import Programs from "./programs";
import Nutrition from "./nutrition";
import loadActivityFeed from "../../middleware/loadActivityFeed";

const AthletePortal = (app) => {
  app.get("/athlete-portal", redirect("/athlete-portal/profile")).at(
    "/athlete-portal/*",
    ensureUser,
    ensureCoach,
    ensurePaid,
    loadActivityFeed,
    rill()
      .get(ensureSetup)
      .use(({ load }, next) =>
        load("listNotifications", {
          limit: 5,
        }).then(next)
      )
      .setup(Calendar)
      .setup(Metrics)
      .setup(Profile)
      .setup(Programs)
      .setup(Nutrition)
  );
};

export default AthletePortal;
